export default 'DRAGGABLE_ITEM';
